import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { externalSource } from './external-source.interface';
import { ExternalSourceService } from './external-source.service';

const service = new ExternalSourceService();

export interface ExternalSourceState {
   externalSources: Array<externalSource>;
}

const ExternalSourceStore: Module<ExternalSourceState, StoreState> = {
   namespaced: true,
   state: {
      externalSources: [],
   },
   getters: {},
   mutations: {
      SET_EXTERNAL_SOURCES(state, externalSources: Array<externalSource>) {
         state.externalSources = externalSources;
      },
   },
   actions: {
      async getExternalSources(context, query: LocationQuery) {
         const response = await service.getExternalSources(query);
         context.commit('SET_EXTERNAL_SOURCES', response.data);
         return response.data;
      },
      async sendCandidate(context, { sourceId, hitIds }: { sourceId: number; hitIds: Array<number> }) {
         const response = await service.sendCandidate(sourceId, hitIds);
         return response;
      },
   },
};

export default ExternalSourceStore;
